import * as React from 'react';

export interface  DrainAccessoriesPartialCheckoutProps {
}

export class DrainAccessoriesPartialCheckout extends React.Component<DrainAccessoriesPartialCheckoutProps, any> {
  public render() {
    return (
      <div className="drain-accessories-partial-line">
        Test
      </div>
    );
  }
}

export default DrainAccessoriesPartialCheckout;